import { render, staticRenderFns } from "./MapaRede.vue?vue&type=template&id=90506158&scoped=true&"
import script from "./MapaRede.vue?vue&type=script&lang=js&"
export * from "./MapaRede.vue?vue&type=script&lang=js&"
import style0 from "./MapaRede.vue?vue&type=style&index=0&id=90506158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90506158",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
